<!-- Compiled at 2026-09-18T12:45:23.821Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<ng-container *ngIf="screen.request"
					><mat-tab-group
						#$tabGroupControl_27="lowgileTabGroupControl"
						class="has-selectedIndexChange-handler"
						[lowgileSelectedTab]="screen.offerId ? 'offers' : 'request'"
						[animationDuration]="300 + 'ms'"
						[mat-stretch-tabs]="false"
					>
						<mat-tab [label]="'Customer request'" [lowgileTabName]="'request'">
							<ng-container
								*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(true)) as $disabled"
							>
								<Orders-CustomerRequestInclude
									[$formDirective]="$formDirective"
									[$disabled]="$disabled"
									[$ignoreValidations]="$ignoreValidations"
									[request]="screen.request"
								>
								</Orders-CustomerRequestInclude>
							</ng-container>
						</mat-tab>
						<mat-tab
							[label]="`Vendor offers (${screen.request.vendorOffers?.length ?? '???'})`"
							[lowgileTabName]="'offers'"
						>
							<ng-container
								*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(true)) as $disabled"
							>
								<Orders-VendorOffersInclude
									[$formDirective]="$formDirective"
									[$disabled]="$disabled"
									[$ignoreValidations]="$ignoreValidations"
									[request]="screen.request"
									[highlightOfferId]="screen.offerId"
								>
								</Orders-VendorOffersInclude>
							</ng-container>
						</mat-tab>
						<mat-tab [label]="'Price comparison'" [lowgileTabName]="'comparison'">
							<ng-container
								*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(true)) as $disabled"
							>
								<Orders-VendorOffersComparisonInclude
									[$formDirective]="$formDirective"
									[$disabled]="$disabled"
									[$ignoreValidations]="$ignoreValidations"
									[request]="screen.request"
									[highlightOfferId]="screen.offerId"
								>
								</Orders-VendorOffersComparisonInclude>
							</ng-container>
						</mat-tab> </mat-tab-group
				></ng-container>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
